import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { repairSelector, setAcceptBudget } from '../store/repair-slice';

const RepairBudget = () => {
  const dispatch = useDispatch();
  const { requesting, acceptBudget } = useSelector(repairSelector);

  return (
    <div className="repair-budget">
      <label>Cliente acepta presupuesto:</label>
      <div className="row">
        <div className="col">
          <button
            disabled={requesting}
            onClick={() => {
              if (acceptBudget) {
                dispatch(setAcceptBudget(null));
              } else {
                dispatch(setAcceptBudget(true));
              }
            }}
            className={clsx({ accept: acceptBudget })}
          >
            Sí acepta
          </button>
        </div>
        <div className="col">
          <button
            disabled={requesting}
            onClick={() => {
              if (acceptBudget) {
                dispatch(setAcceptBudget(false));
              } else if (acceptBudget === false) {
                dispatch(setAcceptBudget(null));
              } else {
                dispatch(setAcceptBudget(false));
              }
            }}
            className={clsx({ decline: acceptBudget === false })}
          >
            NO acepta
          </button>
        </div>
      </div>
    </div>
  );
};

export default RepairBudget;
